import { render, staticRenderFns } from "./ProcessTypeColumn.vue?vue&type=template&id=6a9dc84f&scoped=true"
import script from "./ProcessTypeColumn.ts?vue&type=script&lang=ts&external"
export * from "./ProcessTypeColumn.ts?vue&type=script&lang=ts&external"
import style0 from "./ProcessTypeColumn.vue?vue&type=style&index=0&id=6a9dc84f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9dc84f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a9dc84f')) {
      api.createRecord('6a9dc84f', component.options)
    } else {
      api.reload('6a9dc84f', component.options)
    }
    module.hot.accept("./ProcessTypeColumn.vue?vue&type=template&id=6a9dc84f&scoped=true", function () {
      api.rerender('6a9dc84f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/NoContract/components/columns/ProcessTypeColumn/ProcessTypeColumn.vue"
export default component.exports